import React, { useState } from 'react'

import Scrim from '@divvy-web/skylab.scrim'

import EnterPhoneNumberModal from '@sputnik/components/VerifyPhoneNumber/EnterPhoneNumberModal'
import VerifyCodeModal from '@sputnik/components/VerifyPhoneNumber/VerifyCodeModal'

export interface VerifyPhoneNumberModalProps {
  onClose: () => void
  onPhoneNumberVerified?: () => void
}

const VerifyPhoneNumberModal = ({ onClose, onPhoneNumberVerified }: VerifyPhoneNumberModalProps) => {
  const [phoneNumberToVerify, setPhoneNumberToVerify] = useState('')

  return (
    <Scrim
      isShowing
      className='fs-unmask'
    >
      <VerifyCodeModal
        isShowing={!!phoneNumberToVerify}
        phoneNumber={phoneNumberToVerify}
        onClose={onClose}
        onGoBack={() => setPhoneNumberToVerify('')}
        onPhoneNumberVerified={onPhoneNumberVerified}
      />
      <EnterPhoneNumberModal
        isShowing={!phoneNumberToVerify}
        onClose={onClose}
        onConfirm={(phoneNumber) => setPhoneNumberToVerify(phoneNumber)}
      />
    </Scrim>
  )
}

export default VerifyPhoneNumberModal
